import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TranslationsManagementService {

  //Observables
    private languageChanged = new Subject<any>();
    languageChanged$ = this.languageChanged.asObservable();

  constructor(private translateService: TranslateService) { }

    changeLanguage(lang: any): void {
    this.translateService.use(lang).subscribe((response: any) => {
      localStorage.setItem('language',lang);
      this.languageChanged.next(lang);
    })

  }
}
